define.alias("shared/utils/hash-code", "calendar/utils/platform-check");